var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SalaryAdvanceInput',{attrs:{"customer":_vm.customer,"topup":_vm.instrument.id,"transfer":_vm.transfer,"arrears":_vm.instrument.arrears}})}
var staticRenderFns = []

export { render, staticRenderFns }